// import React, { Component } from "react";
// import ReactJWPlayer from 'react-jw-player';
// class TestingVideo extends Component {
//   render() {
    // const playlist = [{
    //     file: "https://dmbf27t3xv7sf.cloudfront.net/converted/j9GH9FbvQh/150.m3u8",
    //     image: 'https://duwun.sgp1.cdn.digitaloceanspaces.com/109929/conversions/j9GH9FbvQh-thumb.jpg'
    //   },
    //  ];
//     return (
      //   <div className='testingVideo'>
      //      <ReactJWPlayer 
      //         customProps={{
      //           floating: true,
      //           autostart: true,
      //         }}
      //         playerId='V4qGuYBl'
      //         playerScript="https://cdn.jwplayer.com/libraries/V4qGuYBl.js"
      //         playlist={playlist}
      //       />
      // </div>
//     );
//   }
// }
// export default TestingVideo;
// import React from 'react';
// import PropTypes from 'prop-types';
// import { Link, Router } from '/routes'
// import ReactJWPlayer from 'react-jw-player';
 
// class ReactJWPlayerContainer extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       videoTitle: '',
//     };
 
//     this.onAdPlay = this.onAdPlay.bind(this);
//     this.onReady = this.onReady.bind(this);
//     this.onVideoLoad = this.onVideoLoad.bind(this);
//     this.onPlay = this.onPlay.bind(this);
//     this.onPause = this.onPause.bind(this);
//     this.click = this.click.bind(this);
//     this.onAutoStart = this.onAutoStart.bind(this);
//     this.playerId = 'V4qGuYBl';
//   }
  
//   onAdPlay(event) {
//     // track the ad play here
//     console.log('onAdPlay')
//   }
//   onVideoLoad(event) {
//     this.setState({
//       videoTitle: 'ko-pauk-kwe-အချိန်နာရီကိုပြောပြနိုင်တဲ့ သတ္တဝါ'
//     });
//     console.log('onVideoLoad')
//   }
//   onReady(event) {
//     const completeVideo = jwplayer().on('complete', function(){
//         Router.pushRoute('videos') 
//     });
//     return completeVideo
//     console.log('onReady')
//   }
//   onPlay(){
//     // setTimeout(function(){ alert("Hello"); }, 3000);
//     console.log('onPlay')
//   }
//   onPause(){
//     console.log('onPause')
//   }
//   click(){
//     setTimeout(function(){ alert("Hello"); }, 3000);
//   }
//   onAutoStart(){
//       console.log('onAutoStart')
//   }
//   render() {
//     const playlist = [{
//       file: "https://dmbf27t3xv7sf.cloudfront.net/converted/j9GH9FbvQh/150.m3u8",
//       image: 'https://duwun.sgp1.cdn.digitaloceanspaces.com/109929/conversions/j9GH9FbvQh-thumb.jpg'
//     },
//    ];
//     return (
//       <div className='react-jw-player-container'>
//         <h4 style={{color: '#282828'}}>{ this.state.videoTitle }</h4>
//         <div className='testingVideo'>
//            <ReactJWPlayer 
//               customProps={{
//                 floating: true,
//               }}
//               playerId='V4qGuYBl'
//               playerScript="https://cdn.jwplayer.com/libraries/V4qGuYBl.js"
//               // playlist="https://cdn.jwplayer.com/v2/playlists/ftm5d2L6"  // for playlist testing
//               playlist={playlist}
//               onAdPlay={this.onAdPlay}
//               onReady={this.onReady}
//               onVideoLoad={this.onVideoLoad}
//               onPlay={this.onPlay}
//               onPause={this.onPause}
//               onAutoStart={this.onAutoStart}
//               isAutoPlay
//             />
//         </div>
//       </div>
//     );
//   }

// }
 

// export default ReactJWPlayerContainer;

import React from 'react';
import PropTypes from 'prop-types';
import { Link, Router } from '/routes'
import ReactJWPlayer from 'react-jw-player';
 
class TestingVideo extends React.Component {
  constructor(props) {
    super(props);
  }
  
  render() {
    return (
      <>
      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa minus neque accusamus expedita omnis quo delectus odio quisquam ipsum incidunt perspiciatis distinctio ut consequuntur, exercitationem enim minima numquam repellat nisi?</p>
      <iframe className="widgetVideoIframe" src="/widgets/videos/d-gogoeateat-mp4-id398" style={{border: 0}}></iframe>
      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa minus neque accusamus expedita omnis quo delectus odio quisquam ipsum incidunt perspiciatis distinctio ut consequuntur, exercitationem enim minima numquam repellat nisi?</p>

    </>
    );
  }
}
// componentDidMount(){
//   var countdown_html = `
// <div id="countdown">
//   <div id="countdown-number"></div>
//   <div class="arrow-right"></div>
//   <svg>
//     <circle r="36" cx="40" cy="40"></circle>
//   </svg>
// </div>
// <div id="countdown-cancel">
//     Cancel
// </div>
// `;  
//   var countdown_wrapper = document.createElement('div');
//   countdown_wrapper.setAttribute("id", "countdown-wrapper");
//   countdown_wrapper.innerHTML = countdown_html; 
//   var player_ele = document.getElementById('playerId');
//   // console.log(player_ele.firstChild)
//   player_ele.insertBefore(countdown_wrapper, player_ele.firstChild);                
  
//   var countdownNumberEl = document.getElementById('countdown-number');
//   var countdown = 5;
//   countdownNumberEl.textContent = countdown;

//   var myCountDown = setInterval(function() {
//   if(countdown == 1)
                        
//     countdown = (--countdown <= 0) ? 5 : countdown;
//     countdownNumberEl.textContent = countdown;
//   }, 1000);                    
  
//   var clearCountdown = function() { 
//       clearInterval(myCountDown);
//       player_ele.removeChild(countdown_wrapper);
//   };
  
//   var countdown_cancel = document.getElementById("countdown-cancel");
//   countdown_cancel.onclick = clearCountdown; 

// }
// }
 

export default TestingVideo;